import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import { useState, useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useAuth } from '../components/auth/useAuth'
import { sendChatbotMessage, clearChatbotMessages } from '../actions/chatbotActions'
import ReactMarkdown from 'react-markdown';

export default function Chatbot() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch = useDispatch()

    const chatBodyRef = useRef(null)

    const { loadingChatbot, chatbotmessages } = useSelector(state => state.chatbot)

    const [message, setMessage] = useState('')

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
    },[dispatch, t])

    useEffect(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTo({
                top: chatBodyRef.current.scrollHeight,
                behavior: 'smooth'
            })
        }
    }, [chatbotmessages, loadingChatbot])

    const handleSendMessage = () => {
        if (!message || !message.trim()) return

        dispatch(sendChatbotMessage(message, chatbotmessages))
        setMessage('')
    }

    return (
        <Container fluid className='contenido p-5'>
            <Row>
                <Col>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center bg-white">
                            <div>
                                <h4 className="mb-0">{t('chatbot.title')}</h4>
                                <small className="text-muted">
                                    {clientauth?.user?.name || ''}
                                </small>
                            </div>
                            <Button
                                variant="secondary"
                                onClick={() => dispatch(clearChatbotMessages())}
                            >
                                {t('chatbot.clear')}
                            </Button>
                        </Card.Header>

                        <Card.Body
                            ref={chatBodyRef}
                            className="p-3 bg-light"
                            style={{ height: '60vh', overflowY: 'auto' }}
                        >
                            {!chatbotmessages?.length && !loadingChatbot && (
                                <div className="chatbot-messages received my-5">
                                    {t('chatbot.welcome')}
                                </div>
                            )}

                            {chatbotmessages?.map((item, index) => (
                                <div
                                    key={index}
                                    className={`chatbot-messages ${item.role} ${item.role === 'user' ? 'send' : 'received'}`}
                                >
                                    <ReactMarkdown>{item.content}</ReactMarkdown>
                                </div>
                            ))}

                            {loadingChatbot && (
                                <div className="chatbot-messages loading">
                                    {t('chatbot.loading')}
                                </div>
                            )}
                        </Card.Body>

                        <Card.Footer className="bg-white">
                            <div className="row">
                                <div className="col-10">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && !loadingChatbot) {
                                                handleSendMessage()
                                            }
                                        }}
                                        placeholder={t('chatbot.placeholder') || 'Escribe tu consulta'}
                                        disabled={loadingChatbot}
                                    />
                                </div>
                                <div className="col-2">
                                    <Button
                                        variant="primary"
                                        className="w-100"
                                        onClick={handleSendMessage}
                                        disabled={loadingChatbot || !message.trim()}
                                    >
                                        {t('chatbot.send') || 'Enviar'}
                                    </Button>
                                </div>
                            </div>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}